const CHATBOT_SESSION_STORAGE_KEY = "chatbotSessionId"

export const getChatbotSessionId = (): string | null => {
  if (typeof window !== "undefined" && window.localStorage) {
    return localStorage.getItem(CHATBOT_SESSION_STORAGE_KEY)
  }
  return null
}

export const setChatbotSessionId = (sessionId: string): void => {
  if (typeof window === "undefined" || !window.localStorage) return

  localStorage.setItem(CHATBOT_SESSION_STORAGE_KEY, sessionId)
}

export const clearChatbotSessionId = (): void => {
  if (typeof window !== "undefined" && window.localStorage) {
    localStorage.removeItem(CHATBOT_SESSION_STORAGE_KEY)

    process.env.GATSBY_DEBUG === "true" &&
      console.log("🧹 Chatbot session localStorage cleared")
  }
}
